/* global Waypoint */

export default class Eyecandy {
  constructor() {
    this.delay = 150;
    this.offset = '85%';

    this.waypoints = [];
  }

  setAnimateInClass(selector) {
    $(selector).each((i, el) => {
      this.waypoints.push(new Waypoint({
        element: el,
        offset: this.offset,
        handler: () => {
          $(el).addClass('animate-dots-in');
        },
      }));
    });
  }
}
